import { User } from 'lib-shared-types-api';

import { useAppSelector } from 'utils/redux/useAppSelector';

import { currentUserRole } from '../currentUserRole/currentUserRole';

type UseCurrentUserResult = {
  /** The current user. */
  readonly user: User;
  /**
   * The map of whether the current user belongs to one of the default roles.
   *
   * @deprecated Use the `access-control` library instead.
   */
  readonly currentRole: ReturnType<typeof currentUserRole>;
};

/** A hook for getting various information on the currently logged in user. */
export const useCurrentUser = (): UseCurrentUserResult => {
  const user = useAppSelector((state) => state.settings.profile.profile);
  const currentRole = currentUserRole(user);

  return { user, currentRole };
};
